export const LEARNING_HUB_URL = 'https://flair.hr/en/learning-hub/';
